import { render, staticRenderFns } from "./Wx_misc_set.vue?vue&type=template&id=39abd97e&scoped=true&"
import script from "./Wx_misc_set.vue?vue&type=script&lang=js&"
export * from "./Wx_misc_set.vue?vue&type=script&lang=js&"
import style0 from "./Wx_misc_set.vue?vue&type=style&index=0&id=39abd97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39abd97e",
  null
  
)

export default component.exports